export const enum BROADCASTMESSAGETAB {
    General = 0,
    Nav = 1,
    AC = 2,
    EB = 3,
    Config = 4,
    Promo = 5
}


export const enum BROADCASTCONTROLS{
    Standalone=1,
    PackSlipIncluded=2,
    IDM=3,
    Confirmation=4,
    IDMios=5,
    IDMWindows=6,
    Push=7,
    Acknowledgment=8,
    Web=9,
    IDMBoth=10
}


export const enum CRITERIANAMES{
    INDS="INDS",
    GENERAL="GENERAL",
    NAVDBSPECIFICGROUP = "NAVDBSPECIFICGROUP",
    NAVDBSPECIFICIDENT ="NAVDBSPECIFICIDENT",
    ACSPECIFIC="AC",
    EBSPECIFIC="EB",
    TITLE="TITLE"
}